import { render, staticRenderFns } from "./DocsToggleButton.vue?vue&type=template&id=e95cc1b8&scoped=true"
import script from "./DocsToggleButton.vue?vue&type=script&lang=js"
export * from "./DocsToggleButton.vue?vue&type=script&lang=js"
import style0 from "./DocsToggleButton.vue?vue&type=style&index=0&id=e95cc1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95cc1b8",
  null
  
)

export default component.exports